import { baseConfiguration } from './Base/configurations/Base.configuration.js';
import { errorMessageConfiguration } from './ErrorMessage/configurations/ErrorMessage.configuration.js';
import { infoMessageConfiguration } from './InfoMessage/configurations/InfoMessage.configuration.js';
import { successMessageConfiguration } from './SuccessMessage/configurations/SuccessMessage.configuration.js';
import { warningMessageConfiguration } from './WarningMessage/configurations/WarningMessage.configuration.js';
import { IMessageConfiguration } from './IMessageConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const messageConfiguration: IMessageConfiguration = {
	base: baseConfiguration,
	errorMessage: errorMessageConfiguration,
	infoMessage: infoMessageConfiguration,
	successMessage: successMessageConfiguration,
	warningMessage: warningMessageConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
};
